export { DocumentationPageContainer as DocumentationPage } from "./container";
